var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-elem',{staticClass:"error-page"},[_c('div',{staticClass:"row text"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v(_vm._s(_vm.$t('error.title')))]),_c('p',[_vm._v(_vm._s(_vm.errorMsg))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }